import { IControlDefinition } from "Grids/Interfaces";
import { IControl } from "Controls/Interfaces";
import { ServiceProvider } from "Service";

/**
 * Factory to create an instance of the control.
 * @hidden
 */
export type ControlFactory = (controlDefinition: IControlDefinition, textBlockCategory: string, serviceProvider: ServiceProvider) => IControl;

/**
 * Configuration for a ControlType.
 * @hidden
 */
export class ControlTypeConfiguration {
    private _controlFactory: ControlFactory;

    // get the factory for this control.
    public get controlFactory() {
        return this._controlFactory;
    }

    /**
     * Create a new Configuration.
     * @param controlFactory The factory for the control.
     */
    constructor(controlFactory: ControlFactory) {
        this._controlFactory = controlFactory;
    }
}